import { Edit } from '@mui/icons-material';
import { Grid, IconButton, useEventCallback } from '@mui/material';
import { memo, ReactElement, useMemo } from 'react';
import Table from 'shell/components/shared/table';
import { headCells } from './constants';
import { noop } from 'shell/utils/noop';
import { generatePath, useNavigate } from 'react-router-dom';
import { OperationObject } from 'system/utils/event-batch/filters-object-to-query-string-batch-event';
import { ActListVM } from 'civil-status/view-models/research-form';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';

interface TableActProps {
  data?: Array<ActListVM>;
  filterSelected?: OperationObject;
  getActListData: (data: OperationObject, page?: number, rowsPerPage?: number) => void;
  tableProps?: Record<string, number>;
  setTableProps: (values: Record<string, number>) => void;
}

const TableActComponent = ({
  data,
  filterSelected,
  getActListData,
  tableProps = {},
  setTableProps,
}: TableActProps): ReactElement => {
  const navigate = useNavigate();

  const updateData = useHttpClient('', {
    options: {
      method: 'PUT',
      loading: true,
      errorCatching: true,
    },
  });

  const onEditPress = useEventCallback((item: ActListVM) => {
    if (!item.idAct) {
      return;
    }

    (
      updateData({
        url: `${__ACT_API_URL__}/bozza/update-data-formazione/${item.idAct}`,
      }) as ResponsePromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');

      navigate({
        pathname: generatePath('/stato-civile/recupero-atti-emergenza/modifica/:idEvento', {
          idEvento: item.idAct || '',
        }),
      });
    });
  });

  const body: Array<ActListVM> = useMemo(() => {
    return (data || []).map((item) => {
      return {
        ...item,
        action: (
          <div className="pmi-d-flex">
            <IconButton
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onEditPress(item);
              }}
              aria-label="Modifica elemento"
              aria-haspopup="true"
              style={{
                padding: '4px',
              }}
            >
              <Edit />
            </IconButton>
          </div>
        ),
      };
    });
  }, [data]);

  const onChangePage = useEventCallback((page: number) => {
    getActListData(filterSelected || {}, page, tableProps.rowsPerPage);

    setTableProps({
      page,
      rowsPerPage: tableProps.rowsPerPage,
    });
  });

  const onChangeRowsPerPage = useEventCallback((rowsPerPage: number) => {
    getActListData(filterSelected || {}, 0, rowsPerPage);

    setTableProps({
      page: 0,
      rowsPerPage,
    });
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Table
          ariaLabel="Lista atti emergenza"
          page={tableProps.page || 0}
          rowsPerPage={tableProps.rowsPerPage || 10}
          body={body}
          count={(body && body[0]?.totalCount) || 0}
          head={headCells}
          onSort={noop}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
          orders={{}}
          isNotLayoutFixed
          noSort
          hideButtons
          isServer
        />
      </Grid>
    </Grid>
  );
};

TableActComponent.displayName = 'Practice Research Emergency - Table Persons component';

const TableAct = memo(TableActComponent);

export default TableAct;
